var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion-btn-base",class:{open: _vm.isOpen},on:{"click":_vm.onBtnClick}},[_c('div',{staticClass:"btn-wrap"},[_c('link-icon',{attrs:{"is-playlist-text-menu":true,"is-opened":_vm.isOpen}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f387bc2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/partials/AccordionBtn.vue
// module id = null
// module chunks = 